import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import {useLazyGetRequirementAdditionalInputFieldForSectionCBySGBPApplicationIdQuery,useLazyGetRequirementListForSectionCBySGBPApplicationIdQuery,useLazyGetCriteriaRatingTickBySGBPProductInformationIdQuery,} from "../../../../app/services/SelfEvaluationForm/selfEvalutionServiceApi";
import { decryptAESID } from "../../../../utils/Encryption";
import { useSectionRequirements } from "../../utils/useSectionRequirement";
import RequirementCard from "../../utils/RequirementCard";
import NoRecordFound from "../../../../components/ui/noRecordFound/NoRecordFound";

const SECTION = "C";

const SectionC = () => {
    const { id } = useParams();
    const [tickRating, setTickRating] = useState(null);
    const {
        state,
        dispatch,
        record,
        fieldList,
        handlePeerReviewerComment,
        handleClarificationSend,
        isFieldInvalid,
        saveLoading,
    } = useSectionRequirements(
        SECTION,
        useLazyGetRequirementListForSectionCBySGBPApplicationIdQuery,
        useLazyGetRequirementAdditionalInputFieldForSectionCBySGBPApplicationIdQuery
    );

    const totalRating = record.length;

    const [getCriteriaRatingTick, { data: criteriaData, isLoading: criteriaLoading, isSuccess: criteriaSuccess }] = useLazyGetCriteriaRatingTickBySGBPProductInformationIdQuery();

    useEffect(() => {
        const applicationId = decryptAESID(id?.toString(), false);
        if (applicationId) getCriteriaRatingTick(applicationId);
    }, [id]); 

    useEffect(() => {
        if (criteriaSuccess && criteriaData) setTickRating(criteriaData);
    }, [criteriaLoading, criteriaSuccess, criteriaData]);

    const submittedRequirementCount = useMemo(() => {
        const requirements = state.sections?.[SECTION]?.requirements || {};
        const requirementIds = record.map((item) => item.sgbpRequirementId);
        return Object.entries(requirements).filter(
            ([key, req]) => requirementIds.includes(Number(key)) && req.files?.length > 0
        ).length;
    }, [state.sections?.[SECTION]?.requirements, record]);

    const sectionCMinRating = useMemo(() => {
        if (!tickRating || submittedRequirementCount === 0) return null;
        const map = {
            1: tickRating.rating1Tick,
            2: tickRating.rating2Tick,
            3: tickRating.rating3Tick,
            4: tickRating.rating4Tick,
        };
        const entries = Object.entries(map);
        const minEntry = entries.reduce((min, current) => (current[1] < min[1] ? current : min));
        const matches = entries.filter(([, tickValue]) => tickValue <= submittedRequirementCount).sort((a, b) => b[1] - a[1]);
        const match = matches.length > 0 ? matches[0] : minEntry;
        return Number(match[0].replace("Tick", ""));
    }, [tickRating, submittedRequirementCount]);

    useEffect(() => {
        dispatch({ type: "SET_SECTION_C_COUNT", value: sectionCMinRating });
    }, [dispatch, submittedRequirementCount, sectionCMinRating]);

    return (
        <div className="section-card">
            <h3 className="section-title">Section C</h3>

            <div className="rating-box">
                <h4>Section C Additional Information</h4>
                <table className="rating-table">
                    <tbody>
                        {[1, 2, 3, 4].map((tick) => (
                            <tr key={tick}>
                                <td>{tick} Tick</td>
                                <td>
                                    <span>
                                        <input disabled className="change-value" value={tickRating?.[`rating${tick}Tick`] || 0} />
                                        / {totalRating}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {record.length > 0 ? (
                <div className="evaluation-table-wrapper">
                    {record.map((item) => {
                        const reqId = item.sgbpRequirementId;
                        const reqData = state?.sections?.[SECTION]?.requirements?.[reqId] || { files: [], comment: "" };
                        const matchedFields = fieldList.filter((f) => f.sgbpRequirementId === reqId);

                        return (
                            <RequirementCard
                                key={reqId}
                                item={item}
                                reqData={reqData}
                                matchedFields={matchedFields}
                                fieldsState={state.sections?.[SECTION]?.fields}
                                isFieldInvalid={isFieldInvalid}
                                caseOfficerComments={reqData.caseOfficerComments}
                                peerReviewerComments={reqData.peerReviewerComments}
                                status={reqData.status}
                                onCommentChange={(val) => handlePeerReviewerComment(reqId, val)}
                                onSave={() => handleClarificationSend(reqId)}
                                saveLoading={saveLoading}
                            />
                        );
                    })}
                </div>
            ) : (
                <NoRecordFound />
            )}
        </div>
    );
};

export default SectionC;